<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">添加</el-button>
    <el-dialog :visible="dialogVisible" title="新增云算力列表" width="800px" @close="closeDialog">
      <el-form :model="val" ref="form" :rules="rules" label-width="150px">
        <el-form-item label="支付币种：" prop="coinType">
          <el-select v-model="val.coinType">
            <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购买发放币种：" prop="distributionCoinType">
          <el-select v-model="val.distributionCoinType">
            <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="挖矿获得币种：" prop="interestCoinType">
          <el-select v-model="val.interestCoinType">
            <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周期：" prop="day">
          <el-input-number v-model="val.day"></el-input-number>
        </el-form-item>
        <el-form-item label="单价：" prop="price">
          <el-input-number v-model="val.price" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="起止时间：" required>
          <el-col :span="9">
            <el-form-item prop="buyStartTime">
              <el-date-picker
                v-model="val.buyStartTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择开始时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="buyEndTime">
              <el-date-picker
                v-model="val.buyEndTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择截止时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="发行总量：" prop="totalFinancing">
          <el-input-number v-model="val.totalFinancing"></el-input-number>
        </el-form-item>
        <el-form-item label="最小抢购数量：" prop="buyMinNum">
          <el-input-number v-model="val.buyMinNum"></el-input-number>
        </el-form-item>
        <el-form-item label="挖矿开始时间：" prop="startTime">
          <el-date-picker
            v-model="val.startTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="图片：" prop="img">
          <upload v-model="val.img"></upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Upload from "components/upload";

export default {
  name: "cornucopiaCreate",
  data() {
    return {
      dialogVisible: false,
      val: {},
      times: [],
      rules: {
        coinType: {
          required: true,
          message: "请填写"
        },
        distributionCoinType: {
          required: true,
          message: "请填写"
        },
        interestCoinType: {
          required: true,
          message: "请填写"
        },
        day: {
          required: true,
          message: "请填写"
        },
        price: {
          required: true,
          message: "请填写"
        },
        totalFinancing: {
          required: true,
          message: "请填写"
        },
        buyMinNum: {
          required: true,
          message: "请填写"
        },
        startTime: {
          required: true,
          message: "请填写"
        },
        img: {
          required: true,
          message: "请填写"
        }
      }
    };
  },
  components: {
    Upload
  },
  computed: {
    ...mapState("mining", ["coinTypeList"])
    // buyStartTime() {
    //   return this.times ? this.times[0] : "";
    // },
    // buyEndTime() {
    //   return this.times ? this.times[1] : "";
    // }
  },
  methods: {
    ...mapActions("mining", ["create"]),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs["form"].resetFields();
    },
    handleSave() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.create({
        ...this.val
      }).then(() => {
        this.$message({
          message: "添加成功！",
          type: "success"
        });
        this.dialogVisible = false;
        this.$emit("refresh");
      });
    }
  }
};
</script>

<style lang="less">
</style>
